import { Component, inject, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { HistoryService, RestService } from '@cumlaude/shared-services';
import { BestuurSettingsComponent } from './bestuur-settings.component';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { RBestuur } from '@cumlaude/service-contract';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-bestuur-bewerken-page',
	templateUrl: './bestuur-bewerken-page.component.html',
	styleUrl: './bestuur-page.component.scss',
	imports: [BestuurSettingsComponent, AsyncPipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BestuurBewerkenPageComponent implements OnInit {
	private readonly route = inject(ActivatedRoute);
	private readonly historyService = inject(HistoryService);
	private readonly restService = inject(RestService);

	bestuur$!: Observable<RBestuur>;

	private id!: number;

	goBack() {
		this.historyService.back();
	}

	ngOnInit() {
		const idParam = this.route.snapshot.paramMap.get('id');
		this.id = Number.parseInt(idParam!);
		if (Number.isNaN(this.id)) throw new TypeError(`Invalid ID: ${idParam}`);

		this.bestuur$ = this.restService.getBestuur(this.id);
	}
}
